/* eslint-disable react/jsx-props-no-spreading */
import {
  ListManager, PageHeader,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import { MISTREATMENT } from '@/lib/enums'
import mistreatments from '@/services/api/mistreatments'
import React from 'react'
import { Link } from 'react-router-dom'

function Mistreatments({ title }) {
  usePageTitle({ title })

  const { data, loading, error } = useAxiosRequest(mistreatments.countStatus)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Contagem das denúncias"
        subtitle="Totais de denúncias por status"
        icon="fas fa-bullhorn"
        rightAction={() => (
            <Link to="/app/mistreatments/form/add" className="btn btn-primary">
              <i className="fas fa-plus" />
              &nbsp;Adicionar
            </Link>
        )}
      />
      <ListManager loading={loading} count={data?.length || 0} error={error}>
        <>
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>Status</th>
                <th width="150px">Quantidade</th>
                <th width="100px" className="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {
                Boolean(data) && data.map((row) => (
                  <tr key={row.status}>
                    <td>{MISTREATMENT.status.t(row.status)}</td>
                    <td className="text-right">{row.count}</td>
                    <td className="text-right">
                      <Link
                        to={`/app/mistreatments/status/${row.status}`}
                        className="btn btn-action btn-sm btn-primary"
                      >
                        <i className="fas fa-folder-open" />
                      </Link>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </>
      </ListManager>
    </Styles.Container>
  )
}

export default Mistreatments
